import React from 'react';

import { SEO } from 'main/components';
import {
  SystemParameters,
  UnbrokenSignal,
  Landing,
  Integrate,
  MissionReady,
  RobustAirframe,
  IronGhost,
  Video,
} from 'modules/mrm2';
// import { Video } from 'modules/dreamX';

export const Mrm2 = () => {
  return (
    <section>
      <SEO seoTitle="Payload Drone - NDAA Compliant Tactical Asset - Orqa" />
      <section className="mrm2-section">
        <Landing />
        <MissionReady />
        <RobustAirframe />
        <UnbrokenSignal />
        <IronGhost />
        <SystemParameters />
        <Video />
        {/* <Video /> */}
      </section>
      <Integrate />
    </section>
  );
};
